























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { fileUploader } from '@/services/qiniu.service.new';
import { ApplicationListController } from '@/services/request.service';
import { saveAs } from 'file-saver';
import { isWechat } from '@/utils/utils';
import moment from 'moment';

@Component
export default class Upload extends Vue {
  @Prop() public studentId!: number;
  @Prop() public index!: number;
  @Prop() public fileName!: string;
  @Prop() public fileType!: number;
  @Prop() public description!: string;
  @Prop({ type: Array, default: () => [] }) public fileList!: Array<any>;
  public visible: boolean = false;
  public loading: boolean = false;
  public fileListToUpload: Array<any> = [];
  public MAXFILECOUNT = 10;
  public moment = moment;

  public deleteFile(index: number): void {
    this.fileListToUpload.splice(index - 1, 1);
  }

  public changeVisible(flag: boolean): void {
    this.visible = flag;
    this.fileListToUpload = [];
  }
 hide() {
      this.visible = false;
    }
  public uploadFile(): void {
    this.loading = true;
    let num: number = 0;
    this.fileListToUpload.forEach((item: any) => {
      const index = item.file.name.lastIndexOf('.');
      const suffix = item.file.name.slice(index).toLowerCase();
      // png，jpeg，jpg，doc，docx，pdf，xlsx，xls
      const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
      if (suffixArray.includes(suffix)) {
        fileUploader(item.file, item.fileName)
          .then((res: any) => {
            const request = {
              studentId: this.studentId,
              applicationListType: this.fileType,
              resourceInfo: res,
            };
            ApplicationListController.uploadApplicationListInfo(request)
              .then(response => {
                this.visible = false;
                this.$message.success(this.$tc('uploadSuccess'));
                this.$emit('getFileList');
              })
              .catch(() => {})
              .finally(() => {
                num++;
                if (num === this.fileListToUpload.length) {
                  this.loading = false;
                }
              });
          })
          .catch(() => {});
      } else {
        num++;
        if (num === this.fileListToUpload.length) {
          this.loading = false;
        }
        this.$message.error(this.$tc('fileTypeErr'));
      }
    });
  }

  public beforeUpload(file: any): boolean {
    const i = file.name.lastIndexOf('.');
    const suffix = file.name.slice(i).toLowerCase();
    const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
    if (!suffixArray.includes(suffix)) {
      this.$message.error(this.$tc('fileTypeErr'));
    } else if (file.size > 10 * 1024 * 1024) {
      this.$message.error(this.$tc('fileSizeErr'));
    } else if (this.fileListToUpload.length >= this.MAXFILECOUNT) {
      this.$message.error(this.$tc('attachmentTip'));
    } else {
      const fileName = file.name.toString();
      this.fileListToUpload = this.fileListToUpload.concat({
        index: this.fileListToUpload.length + 1,
        file,
        fileName,
      });
    }
    return false;
  }

  public openFile(resource: any): void {
    const suffixArray = ['doc', 'docx', 'xls', 'xlsx'];
    if (suffixArray.includes(resource.type)) {
      this.download(resource);
    } else {
      window.open(resource.resourceUrl);
    }
  }

  public handleMask(): void {
    const mask = document.getElementById('weixin-mask');
    if (mask) {
      mask.style.display = 'flex';
    }
  }

  public download(info: any): void {
    if (isWechat()) {
      this.handleMask();
    } else {
      saveAs(info.resourceUrl, info.name);
    }
  }
}
